import {Component, ViewEncapsulation, ElementRef, Inject, Input} from "@angular/core";

@Component({
  templateUrl: './subheader.component.html',
  selector: 'subheader',
  styleUrls: [ './subheader.component.scss' ],
  encapsulation: ViewEncapsulation.None
})

export class SubHeaderComponent {
  @Input() title: string;
  @Input() class: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/decorator/subheader/subheader.component.ts